export const namespace = "concert/";
export const SET_CONCERT_ID = "SET_CONCERT_ID";
export const SET_CONCERT_INFO = "SET_CONCERT_INFO";
